module.exports = __webpack_public_path__ + "img/technology_steps.5be1514f.png";